// extracted by mini-css-extract-plugin
export default {"wrapper":"AiAnalysis_wrapper__F27qx","header":"AiAnalysis_header__uwCJv","content":"AiAnalysis_content__fsbeh"};